import styles from "./Forecast.module.css";
import Moment from "moment";

export default function Today(props: {
  granularity: string;
  handleUpdateSearchParams: (params: any) => void;
}) {
  return (
    <div
      className={styles["forecast-today"]}
      onClick={() => {
        let startDate = Moment().startOf("day").unix().toString();
        let endDate = Moment().endOf("day").unix().toString();
        if (props.granularity === "week") {
          startDate = Moment().startOf("isoWeek").unix().toString();
          endDate = Moment().endOf("isoWeek").unix().toString();
        } else if (props.granularity === "month") {
          startDate = Moment().startOf("month").unix().toString();
          endDate = Moment().endOf("month").unix().toString();
        } else if (props.granularity === "quarter") {
          startDate = Moment().startOf("quarter").unix().toString();
          endDate = Moment().endOf("quarter").unix().toString();
        } else if (props.granularity === "year") {
          startDate = Moment().startOf("year").unix().toString();
          endDate = Moment().endOf("year").unix().toString();
        }
        props.handleUpdateSearchParams({
          startDate: startDate,
          endDate: endDate,
          granularity: props.granularity,
        });
      }}
    >
      Today
    </div>
  );
}
